import script from "./Card.vue?vue&type=script&setup=true&lang=js"
export * from "./Card.vue?vue&type=script&setup=true&lang=js"

import "./Card.vue?vue&type=style&index=0&id=1da940e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da940e8"]])

export default __exports__